import { Box, Typography } from '@mui/material';
import { DS, sectionBarSx } from './ds';

interface SectionTitleProps {
  children: React.ReactNode;
  color?: string;
}

const SectionTitle = ({ children, color = DS.blue }: SectionTitleProps) => (
  <Box display="flex" alignItems="center" mb={3}>
    <Box sx={sectionBarSx(color)} />
    <Typography variant="h6" fontWeight={700} color={DS.textPrimary}>
      {children}
    </Typography>
  </Box>
);

export default SectionTitle;
